import { useLocalStorage } from 'usehooks-ts';

import { storageKeys } from '@app/constants';

export const useAppLocale = () => {
  const [locale, setLocale] = useLocalStorage<string>(storageKeys.locale, 'es');

  return { locale, setLocale };
};
